import { ColumnDef } from "@tanstack/react-table";
import RenderIf from "components/RenderIf/RenderIf";
import { APARTMENT_TAB_KEY, APARTMENT_WITH_RETAIL_INCOME_TABS, RETAIL_TAB_KEY } from "views/ProFormaTable/constants";
import { IFormattedCashFlowPeriod } from "views/ProFormaTable/types";
import ApartmentIncome from "../ApartmentIncome/ApartmentIncome";
import RetailOfficeIndustrialIncome from "../RetailOfficeIndustrialIncome/RetailOfficeIndustrialIncome";

export interface IApartmentWithRetailIncomeProps {
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
    monthlyPeriodOptions: IFormattedCashFlowPeriod[];
    currentTab: keyof typeof APARTMENT_WITH_RETAIL_INCOME_TABS;
}

export const ApartmentWithRetailIncome = ({ 
    operationBeginIndex, 
    baseCashFlowColumns, 
    monthlyPeriodOptions,
    currentTab
}: IApartmentWithRetailIncomeProps) => {
    return (
        <>
            <RenderIf isTrue={currentTab === APARTMENT_TAB_KEY}>
                <ApartmentIncome
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    showEgrBreakdown
                />
            </RenderIf>
            <RenderIf isTrue={currentTab === RETAIL_TAB_KEY}>
                <RetailOfficeIndustrialIncome
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
            </RenderIf>
        </>
    );
};
